import type { ComponentProps } from "react";
import { tv } from "tailwind-variants";

const tableWrapperVariants = tv({
  base: "relative w-full overflow-x-auto",
});

export const TableWrapper = ({ className, ...props }: ComponentProps<"table">) => {
  return (
    <div className={tableWrapperVariants({ className })}>
      <table className="w-full border-separate border-spacing-0 text-left" {...props} />
    </div>
  );
};
